export default "__VITE_PUBLIC_ASSET__525f2816__"